<div id="Invoicegenerate">
  <div class="border_">
    <h1 class="textcenter">INVOICE</h1>
    <div style="margin: 0px 20px px 20px">
      <div>
        <span>
          <hr class="blacksolid" />
        </span>
        <div style="margin: 17px 0px 63px 0px">
          <span class="floatright">
            Optimum Financial Solutions Pvt. Ltd.
            <br />
            A-7, 32 Corporate Avenue,
            <br />
            Off Mahakali Caves road,
            <br />
            Andheri East, Mumbai – 400093
            <br />
            <span class="blue">www.optimumfintech.com</span>
          </span>
          <span class="LogoImg">
            <img
              alt="N/A"
              class="logo_img"
              src="../../assets/images/IFA/OptimumLogo.svg"
              width="130px"
              height="60px" />
          </span>
        </div>
        <div style="margin: 0px 0px 0px 0px">
          <hr />
          <span>Invoice no.: {{ InvoiceNo }}</span>
          <span class="floatright">Date: {{ PaymentDate }}</span>
          <hr />
          <div>
            <span>BILL NO,</span>
            <br />
            <p>{{ BillTo }}</p>
            <p>
              <span>GST No. 27AAECS6192E1Z7</span>
            </p>
          </div>
          <br />
          <table>
            <tr>
              <th>SR.NO.</th>
              <th>DESCRIPTION</th>
              <th>QTY.</th>
              <th>TERM</th>
              <th>AMOUNT</th>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td class="textright">1</td>
              <td>GoDigital MF Software Annual Maintenance Charges</td>
              <td>1</td>
              <td>1year</td>
              <td>{{ Amount }}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </table>
          <table style="width: 100%">
            <tr>
              <th rowspan="10">
                Payable to: Optimum Financial Solutions Pvt. Ltd. PAN NO:
              </th>
              <th>
                Sub Total
                <span class="floatright">{{ Amount }}</span>
              </th>
            </tr>
            <tr>
              <th>
                Total (Inclusive of taxes)
                <span class="floatright">{{ TotalInc }}</span>
              </th>
            </tr>
            <tr>
              <th>
                Deduction
                <span class="floatright">{{ Deduction }}</span>
              </th>
            </tr>
            <tr>
              <th>
                Discount
                <span class="floatright">{{ Discount }}</span>
              </th>
            </tr>
            <tr>
              <th>
                Billed Amount
                <span class="floatright">{{ BilledAmount }}</span>
              </th>
            </tr>
            <tr>
              <th>
                Taxable Amount
                <span class="floatright">{{ TaxAmount }}</span>
              </th>
            </tr>
            <tr>
              <th>
                Taxes(18% GST)
                <span class="floatright">{{ TaxAmtGst }}</span>
              </th>
            </tr>
            <tr>
              <span *ngIf="GSTNO == 'Y'">
                <th>
                  SGST
                  <span class="floatright">{{ SGST }}</span>
                </th>
              </span>
            </tr>
            <tr>
              <th>
                CGST
                <span class="floatright">{{ CGST }}</span>
              </th>
            </tr>
            <tr>
              <th>
                Final Billed Amount (INR)
                <span class="floatright">{{ BilledAmount }}</span>
              </th>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<button class="CommonSubmitButton active" (click)="print()">Print</button>
